<template>
    <div class="editor">
        <div class="mb-2" v-if="!isNew">
            <div v-if="error" class="alert alert-danger my-2" role="alert">
                {{ error }}
            </div>
            <label for="assignment-name" class="section-heading">{{ lang['model.path_name'] }}</label>
            <input id="assignment-name" class="form-control" type="text" v-model="path.name" @keyup="error = false">
        </div>

        <div v-if="!isNew && !invalid" class="d-flex justify-content-between align-items-center">
                <label for="problems" class="section-heading">{{ lang['general.problems'] }}</label>
                <div class="new-problem" @click="addPathProblem">{{ lang['assignment.new_problem'] }} <i class="fas fa-plus-circle ml-1"></i></div>
        </div>
        
        <div v-if="loadingProblems && !invalid && !isNew" class="mt-4 flex-r flex-center" style="font-size: 1.25em;">
            <div><i class="far fa-spinner fa-spin mr-2 blue"></i> {{ lang['general.loading'] }}</div>
        </div>
        <div v-else>
            <div v-for="(problem, index) in problems" class="problem-card" :class="{ 'selected':selectedIndex == index }"  @click="selectedIndex = index">
                <div class="problem-text" @click="problemAction(problem, 'edit')" v-html="$options.filters.stripAndTruncate(problem.name, 32, '')">PROBLEM</div>
                <div title="Remove problem from path">
                    <!-- <i class="fas fa-pencil mr-3" @click="problemAction(problem, 'edit')"></i> -->
                    <i class="fal fa-times" @click="problemAction(problem, 'removePath')"></i>
                </div>
            </div>
        </div>

        <template v-if="isNew">
                <div class="prompt">{{ lang['model.path_instructions'] }}</div>
                <button class="btn btn-primary btn-gradient w-100" @click="startPath">+ {{ lang['button.define_path'] }}</button>
        </template>

        <template v-if="invalid">
                <div class="prompt">This path is incomplete. Either complete it by clicking complete path and selecting the choices to complete it, or remove it entirely by clicking delete.</div>
                <button class="btn btn-primary btn-gradient w-100 mb-2" @click="completePath">Complete Path</button>
                <button class="btn btn-delete btn-gradient w-100" @click="deleteInvalidPath">Delete Path</button>
        </template>

    </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
    props: ['content', 'model'],
    data() {
        return {
            path: this.content,
            problems: [],
            isNew: false,
            invalid: false,
            error: false,
            loadingProblems: true,
            selectedIndex: -1,
            lang: lang,
        }
    },

    mounted() {
        if(this.content.id && this.content.invalid == 0) {
            this.getPathProblems();
        } else if(this.content.invalid > 0) {
            this.invalid = true;
        } else {
            this.isNew = true;
        }
    },

    methods: {
        addPathProblem() {
            const data = {
                pathId: this.content.id,
                modelId: this.model,
            }
            editingProblem = true;
            bus.$emit('addProblem', data, this.path, false);
        },

        updateDrawer(id) {
            $.get('/paths/' + id + '/model/' + this.model,
            res => {
                this.path = res;
                this.isNew = false;
            })
            .catch((error) => {
                bus.$emit('popupError', error);
            });
        },

        startPath() {
            bus.$emit('checkTimeout');
            problemEditorOpen = true;
            definePath = true;
            defineExistingPathID = 0;
            switchToMode('path');
        },

        completePath() {
            problemEditorOpen = true;
            definePath = true;
            defineExistingPathID = this.content.id;
            modelMode = 'path';
            redrawPath(this.content.path);
        },

        deleteInvalidPath() {
            bus.$emit('deletePath', this.content, 'path');
        },

        getPathProblems() {
            this.problems = [];
            this.loadingProblems = true;
            $.get('/paths/' + this.path.model_id + '/path/' + this.path.id,
                res => {
                    this.loadingProblems = false;
                    this.problems = res;
                })
            .catch((error) => {
                bus.$emit('popupError', error);
            });
        },

        updateProblems(problem, command) {
            switch(command) {
                case 'create':
                    this.problems.push(problem);
                    break;
                case 'delete':
                    this.problems.splice(this.problems.indexOf(problem), 1);
                    break;
            }
        },

        problemAction(problem, command) {
            var $this = this;
            switch(command) {
                case 'edit':
                    editingProblem = true;
                    bus.$emit('editProblem', problem, this.path, false);
                    break;
                case 'removePath':
                    $.post('/models/' + problem.model_id + '/problempath', {
                        id: problem.id,
                        path_id: 0,
                    }, function (response) {
                        if(!response.error) {
                            $this.getPathProblems();
                        }
                    }).catch((error) => {
                        bus.$emit('popupError', error);
                    });
                    break;
                }
        },

        popuplatePath(path) {
            highlightProfilePath(null, path);
        },

        remove() {
            this.$emit('close');
        },

        save() {
            if(!this.path.name) {
                this.error = lang['model.path_name_prompt'];
            } else if (this.path.name.length > 1024) {
                this.error = lang['model.path_name_length_prompt'];
            } else {
                const { id, name } = this.path;
                $.post('/paths/' + this.model, { id, name },
                    res => {
                        if(!res.error) {
                                this.$emit('close');
                        } else {
                                this.error = lang['model.path_save_error'];
                        }
                    })
                .catch((error) => {
                    bus.$emit('popupError', error);
                });
            }
        }
    },

    created() {
        bus.$on('save', this.save);
        bus.$on('update', this.getProblems);
        bus.$on('populatePath', this.popuplatePath);
        bus.$on('updatePathProblems', this.updateProblems);
        bus.$on('addPath', this.updateDrawer);
        bus.$on('removePath', this.remove);
    },

    beforeDestroy() {
        bus.$off('save', this.save);
        bus.$off('update', this.getProblems);
        bus.$off('populatePath', this.popuplatePath);
        bus.$off('updatePathProblems', this.updateProblems);
        bus.$off('addPath', this.updateDrawer);
        bus.$off('removePath', this.remove);
    }
}
</script>
